import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RedeSocialComponent } from 'src/app/modulos/rede-social/rede-social.component';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import { PipeModule } from '../../pipe/pipe.module';

@NgModule({
  declarations: [
    
  ],
  exports: [

  ],
  imports: [
    LazyLoadImageModule,
    PipeModule,  
    CommonModule
  ]
})
export class ModuloRedeSocialModule { }
